import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Stats } from "./components/stats";
import { Services } from "./components/services";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Gallery } from "./components/gallery";
import { Process } from "./components/process";
// import { Testimonials } from "./components/testimonials";
// import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 88,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div className="overflow-x-hidden">
      <Navigation />
      <main>
        <Header data={landingPageData.Header} />
        <Stats data={landingPageData.Stats} capabilities={landingPageData.Capabilities} />
        <Services data={landingPageData.Services} />
        <Features data={landingPageData.Features} />
        <About data={landingPageData.About} />
        <Gallery data={landingPageData.Gallery} />
        <Process data={landingPageData.Process} />
        {/* <Testimonials data={landingPageData.Testimonials} /> */}
        {/* <Team data={landingPageData.Team} /> */}
        <Contact data={landingPageData.Contact} />
      </main>
      <Footer data={landingPageData.Contact} />
    </div>
  );
};

export default App;
